const emailSubject = 'Community Locker Storage Request'

const getHtmlBody = ({name, email, number = 'Unspecified', storageSize = 'Unspecified', date = 'Unspecified', comments = 'Unspecified'}) => {
  return `Community%20Locker%20Storage%20Request%0AName%3A%20${name}%0AEmail%20Address%3A%20${email}%0APhone%20Number%3A%20${number}%0AStorage%20Size%3A%20${storageSize}%0ADate%20Needed%3A%20${date}%0AComments%20and%20Questions%3A%20${comments}`
}

export { emailSubject, getHtmlBody }
